var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Typography } from '@robinpowered/ui-kit';
/**
 * Shared name + email lines for an invitee/attendee row, used by both the
 * composer invitee list (InviteeRow) and the event details attendees card
 * (AttendeesCard) so the two surfaces stay consistent.
 *
 * `name` can be an empty string (user with no name) — in that case the email
 * is promoted to the bold primary line and the secondary line is omitted.
 */
export var InviteeNameEmail = function (_a) {
    var name = _a.name, email = _a.email;
    var primary = name || email;
    if (!primary) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(PrimaryLine, { strong: true, children: primary }), !!name && !!email && (_jsx(SecondaryLine, { type: "secondary", size: "small", children: email }))] }));
};
var OverflowStyles = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n"], ["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n"])));
var PrimaryLine = styled(Typography.Text)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), OverflowStyles);
var SecondaryLine = styled(Typography.Text)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), OverflowStyles);
var templateObject_1, templateObject_2, templateObject_3;
